/* istanbul ignore file */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ErrorBoundary } from 'bernie-view';
import { ExperienceTemplateRenderer, ExperienceTemplateRendererContextProvider } from 'experience-template-renderer-react';
import { isMobile } from 'src/common/utils/is-mobile';
import { listViewPillsExperimentTemplate } from 'templates/search/list-view-pills-experiment';
import { listViewTemplate } from 'templates/search/list-view.template';
import { componentLibrary } from 'components/search/template-components';
export const TemplateRenderer = inject('experiment', 'pageLayout', 'multiItem', 'context')(observer(({
  experiment,
  pageLayout,
  multiItem,
  context
}) => {
  var _a, _b, _c, _d;
  const useListViewTemplate = !(multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath());
  const useMwebBEXQuickFiltersTemplate = isMobile(context) && ((_b = (_a = experiment === null || experiment === void 0 ? void 0 : experiment.exposures) === null || _a === void 0 ? void 0 : _a.Quick_Filters_xLOB_Lodging_mWeb_Retest) === null || _b === void 0 ? void 0 : _b.bucket) === 1;
  const templateComponents = useMwebBEXQuickFiltersTemplate ? listViewPillsExperimentTemplate.components : listViewTemplate.components;
  return React.createElement(ExperienceTemplateRendererContextProvider, {
    library: componentLibrary
  }, React.createElement(ErrorBoundary, {
    label: "lodging.template.renderer"
  }, React.createElement(ExperienceTemplateRenderer, {
    templateComponents: useListViewTemplate ? templateComponents : (_d = (_c = pageLayout === null || pageLayout === void 0 ? void 0 : pageLayout.getSRPTemplate(pageLayout === null || pageLayout === void 0 ? void 0 : pageLayout.templateName)) === null || _c === void 0 ? void 0 : _c.components) !== null && _d !== void 0 ? _d : []
  })));
}));